module.exports = __webpack_public_path__ + "static/media/fhi-logo-hvit-eng.377ab22b.svg";